// components/PublicRoute.jsx
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('token');

  if (token) {
    try {
      const decoded = jwtDecode(token);
      const isExpired = decoded.exp * 1000 < Date.now();

      if (!isExpired) {
        // Token exists and is still valid → redirect to /home
        return <Navigate to="/home" replace />;
      }
      else {
        localStorage.removeItem('token');
      }
    } catch (error) {
      localStorage.removeItem('token');
      // Token is invalid, fall through to render children
      console.error('Invalid token in PublicRoute', error);
    }
  }

  return children;
};

export default PublicRoute;
